export const EMAIL = 'email';
export const KAKAO = 'kakao';
export const IN_PERSON = 'IN_PERSON';
